

var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/util/getDisplayName.js
// module id = 1106
// module chunks = 0